import React, { useEffect, useState } from 'react';

const Skills = () => {
  const [skills, setSkills] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetch('/skills.json')
      .then(res => {
        if (!res.ok) throw new Error('Failed to load skills data');
        return res.json();
      })
      .then(setSkills)
      .catch(err => setError(err.message))
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <section className="resume-skills"><p>Loading...</p></section>;
  if (error) return <section className="resume-skills"><p>Error: {error}</p></section>;

  return (
    <section className="resume-projects">
      <h2>Skills</h2>
      <ul style={{listStyle: 'none', padding: 0}}>
        {skills.map((skill, idx) => (
          <li key={idx} style={{marginBottom: '18px'}}>
            
            <div className="project-item">
              <h3>{skill.skillArea}</h3>
              <p>{skill.skillSet}</p>
            </div>
          </li>
        ))}
      </ul>
    </section>
  );
};

export default Skills;
